export default "__VITE_ASSET__JO8KOJJp__"